import styled from 'styled-components'

export const Container = styled.div`
    background: #ffffff;
    border-bottom: solid 1px #b9b9b9;
`